import {AttrsSchema, Component} from 'panel';

import {defineAndMakeJsxFactory} from 'common/util/jsx';
import {panel2react} from 'common/util/react';
import {Organization} from 'app_api/me/types';
import {IronContextRegistry} from 'common/report/context-registry';

import {template} from './template';
import css from './index.inline.styl';

export interface CreateProjectModalAttrs {
  'organization-id'?: number;
  'project-id'?: number;
  open: boolean;
  orgs?: Organization[];
  'is-setup'?: boolean;
}

type JsxProps = {
  attrs: CreateProjectModalAttrs;
  on?: {
    cancel?: (evt: TODO) => void;
    create?: (evt: TODO) => void;
  };
};

export class CreateProjectModal extends Component<
  EmptyObj,
  CreateProjectModalAttrs,
  unknown,
  unknown,
  IronContextRegistry
> {
  static get attrsSchema(): AttrsSchema<CreateProjectModalAttrs> {
    return {
      ...super.attrsSchema,
      'organization-id': {type: `number`, description: `id for current organization`},
      'project-id': {type: `number`},
      open: {type: `boolean`, description: `whether or not its open`},
      orgs: {type: `json`},
      'is-setup': {type: `boolean`, description: `from setup page or not`},
    };
  }
  get config() {
    return {
      css,
      contexts: [`i18n` as const],
      defaultState: {},
      useShadowDom: true,
      template,
    };
  }

  connectedCallback() {
    super.connectedCallback();
    if (this.attr(`is-setup`)) {
      mixpanel.track(`[Set Up] Project Create Modal Opened`);
    }
  }
}

export const CreateProjectModalEl = defineAndMakeJsxFactory<JsxProps>(`mp-create-project-modal`, CreateProjectModal);
export const CreateProjectModalReact = panel2react<JsxProps>(`mp-create-project-modal`, CreateProjectModal);
